const isCustomUpload = (url) => url && (url.startsWith("https://music.wixstatic.com/mp3") || url.startsWith("https://video.wixstatic.com/video"));
export {
  isCustomUpload
};
//# sourceMappingURL=is-custom-upload.js.map
